import wsMultipleInputComponent from './ws-multiple-input.component';

const injectorName = 'ws.common.multiple-input';

angular.module(injectorName, [])
  .component('wsMultipleInput', wsMultipleInputComponent);

export default injectorName;



// WEBPACK FOOTER //
// ./src/multiple-input/index.js